import React from 'react';

// The support address in legal pages (2026-10-21): a mailto link whose text is an isolated LTR run, so inside
// Hebrew (RTL) text the address never reorders and never merges with surrounding punctuation or a Hebrew prefix.
export const SUPPORT_EMAIL = 'support@ritmoiq.com';

export default function LegalEmail({ className = 'text-blue-400 hover:underline' }) {
  return (
    <a href={`mailto:${SUPPORT_EMAIL}`} className={className}>
      <bdi dir="ltr">{SUPPORT_EMAIL}</bdi>
    </a>
  );
}
